import { Injectable } from "@angular/core";
import { ForgotPasswordService } from "./forgotpassword.service";
import { ForgotPasswordRequestVO } from "./forgotpassword.model";

import { Headers } from '@angular/http';
import { environment } from "../../environments/environment"
import { HttpService } from "../http/http.service";

@Injectable()
export class ForgotPasswordServiceImpl implements ForgotPasswordService {
    
    constructor(private httpService: HttpService,
        ) { }
    

    updatePassword(forgotPasswordRequestVO: ForgotPasswordRequestVO): Promise<void> {
        let url = `${environment.SSO_API_ENDPOINT}/signin/resetPassword`;
        console.log('url = ' + url);
      
        let body = JSON.stringify(forgotPasswordRequestVO);
        let headers = new Headers({
            'Authorization': 'None',
            'Content-Type': 'application/json'
          });
        return this.httpService.put(url, body, headers).toPromise()
          .then(responseEnvelope => 
              console.log("Password Successfully changed")
             , error => {
            console.error("Error received in reset password service. " + JSON.stringify(error));
            throw error;
          });
    }
  
}


// WEBPACK FOOTER //
// ./src/app/forgotpassword/forgotpassword.service.impl.ts